import { useDeleteCustomRole } from './useDeleteCustomRole';
import { useContext, useState } from 'react';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { useHistory } from 'react-router-dom';
import { UseMutateFunction, useQueryClient } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseDeleteCustomRoleModalFacade = () => {
  isDeleteCustomRoleModalOpen: boolean;
  toggleDeleteCustomRoleModalOpen: () => void;
  deleteCustomRole: UseMutateFunction<AxiosResponse<void>, ErrorResponse, string>;
  isDeletingCustomRole: false | true;
};

export const useDeleteCustomRoleModalFacade: UseDeleteCustomRoleModalFacade = () => {
  const { showNotification } = useContext(NotificationsContext);
  const history = useHistory();
  const queryClient = useQueryClient();
  const [isDeleteCustomRoleModalOpen, setIsDeleteCustomRoleModalOpen] = useState(false);

  const { mutate: deleteCustomRole, isLoading: isDeletingCustomRole } = useDeleteCustomRole({
    onSuccess: () => {
      showNotification('Custom role deleted successfully');
      queryClient.invalidateQueries(`custom-roles`);
      history.push('/custom-roles');
    },
    onError: () => {
      showNotification('Unable to update role information. Try again later');
    },
  });

  const toggleDeleteCustomRoleModalOpen = () => {
    setIsDeleteCustomRoleModalOpen((p) => !p);
  };

  return {
    isDeleteCustomRoleModalOpen,
    toggleDeleteCustomRoleModalOpen,
    deleteCustomRole,
    isDeletingCustomRole,
  };
};
